import useTableColumns from "./useTableColumns"
import useCreatePractices from './useCreatePractices'

export default { useTableColumns, useCreatePractices }